module.exports = __webpack_public_path__ + "static/media/nate.7595e769.png";